import { useOnSurfaceNodeSave } from 'components/canvas/hooks/use-on-surface-node-save';
import useMutation from 'hooks/use-mutation';
import { createSurfaceImageNodeMutation } from 'graphql/surface-node/mutations/surface-image-node/create-surface-image-node';
import { updateSurfaceImageNodeMutation } from 'graphql/surface-node/mutations/surface-image-node/update-surface-image-node';
import { pick } from 'lodash';
import { surfaceNodesQuery } from 'graphql/surface-node/queries/surface-nodes';

export default function useSaveSurfaceImageNode(surfaceId: string) {
  const onSurfaceImageNodeCreate = useOnSurfaceNodeSave(
    'createSurfaceImageNode',
  );

  const onSurfaceImageNodeUpdate = useOnSurfaceNodeSave(
    'updateSurfaceImageNode',
  );

  const [createSurfaceImageNode] = useMutation(createSurfaceImageNodeMutation, {
   // update: onSurfaceImageNodeCreate as any,
  });

  const [updateSurfaceImageNode] = useMutation(updateSurfaceImageNodeMutation, {
    update: onSurfaceImageNodeUpdate as any,
  });

  return function saveSurfaceImageNode(params) {
    const isUpdate = params.variables.input.id;

    if (isUpdate) {
      params.variables.input = pick(params.variables.input, [
        'id',
        'name',
        'url',
        'format',
      ]);

      return updateSurfaceImageNode(params);
    }
    params.variables.input = pick(params.variables.input, [
      'surface',
      'name',
      'url',
      'format',
      'position',
    ]);

    return createSurfaceImageNode(params);
  };
}
